module.exports = __webpack_public_path__ + "static/media/3.77ca4cf2.jpg";